import { ViewController, JsonFeed, ModelUpdateEvent, DataReceiveEvent, MaintenanceEvent, PlaybackStartEvent,
         VideoReloadEvent, TimeUpdateEvent, ChannelSwitchEvent, GuiResizeEvent } from "@gaming/srvg-classes-core";
import { TerminalView } from "../../View/AppView/TerminalView";
import { TitlebarController } from "./TitlebarController";
import { VideoController } from "./VideoController";
import { OverlayViewController } from "./OverlayViewController";
import { MatchdayAreaController } from "./MatchdayAreaController";
import { PhaseChangeEvent } from "../../Event/PhaseChangeEvent";


export class TerminalViewController extends ViewController {
    terminalView: TerminalView;

    overlayViewController: OverlayViewController;
    titlebarController: TitlebarController;
    videoController: VideoController;
    matchdayAreaController: MatchdayAreaController;

    resizeTimeout: any;

    constructor( options ) {
        options = options || {};
        options.view = options.terminalView || null;
        super( options );
        this.name = 'vblTerminalViewController';

        this.terminalView = options.terminalView || null;

        /******************* initialize controllers ************************/

        this.titlebarController       = this.addChildViewController( new TitlebarController( { titlebar: this.terminalView.titlebar } ) );

        this.videoController = this.addChildViewController( new VideoController( {
            videoView: this.terminalView.videoView,
            videoControlBar: this.terminalView.videoControlBar,
            channel: srvg.videooptions.defaultchannel
        } ) );

        this.overlayViewController    = this.addChildViewController( new OverlayViewController( {
            overlayView: this.terminalView.overlayContainerView,
            teamAssignmentFeed: new JsonFeed( { url: srvg.url.teamJerseyAssignment } ),
            teamResultFeed: new JsonFeed( { url: srvg.url.teamResult } )
        } ) );

        this.matchdayAreaController = this.addChildViewController( new MatchdayAreaController({
            matchdayArea: this.terminalView.matchdayArea,
            matchdaypickerController: null
        }) );

        this.resizeTimeout = null;


        /** FLOST **/

        if( srvg.videooptions.flostVideosets ) {
            this.videoController.initializeLocalStorage();
        }

        // force reload
        // activate for all retail instances
        if (srvg.featuresInstances.getEnableForceReloadFullRetail()){
            srvg.flost.setForceReloadCompatibleWithMinute( srvg.featuresInstances.getForceReload() );
        }else{
            // activate only for flost
            if( srvg.videooptions.flostVideosets ) {
                srvg.flost.setForceReloadCompatibleWithMinute( srvg.featuresInstances.getForceReload() );
            }
        }

        /******************* connect components ************************/

        var exch = srvg.eventExchange;

        //___________________eventSubscriber____________________eventProvider_______________eventType___________eventHandler_________________

        exch.addEventHandler(app.customerIntegration,          'all',                      ModelUpdateEvent );
        this.terminalView.matchdayArea.matchdayAreaModel.addSubscriberForEvent( app.matchIdsFeedController, ModelUpdateEvent );

        app.oddsfeedController.addSubscriberForEvent( this.matchdayAreaController, DataReceiveEvent );

        app.timelineController.addSubscriberForEvent(srvg.maintenance,           MaintenanceEvent );
        app.timelineController.addSubscriberForEvent(app.customerIntegration,    PhaseChangeEvent );
        app.timelineController.addSubscriberForEvent(app.server,                 TimeUpdateEvent );
        app.timelineController.addSubscriberForEvent(this.overlayViewController, PhaseChangeEvent );
        app.timelineController.addSubscriberForEvent(this.videoController,       PhaseChangeEvent );
        app.timelineController.addSubscriberForEvent(this.titlebarController,    PhaseChangeEvent );
        app.timelineController.addSubscriberForEvent( this.videoController,      VideoReloadEvent );

        exch.addEventHandler(this.videoController,             'all',                     PlaybackStartEvent );
        exch.addEventHandler(this.videoController,             'all',                     ChannelSwitchEvent );
        exch.addEventHandler(this.overlayViewController,       'all',                     ChannelSwitchEvent );
        exch.addEventHandler(app.customerIntegration,          'all',                     ChannelSwitchEvent );


        app.addSubscriberForEvent( this, GuiResizeEvent );

        /******************* start components ************************/
        app.timelineController.startPolling();
        if( ! srvg.videooptions.flostVideosets ) {
            this.videoController.play();
        }
        app.customerIntegration.startCustomerActions();
    }

    handleGuiResizeEvent( event:GuiResizeEvent, provider ) {
        var layoutDelay = 200;
        if( this.resizeTimeout ) {
            window.clearTimeout( this.resizeTimeout );
        }

        var that = this;
        this.resizeTimeout = window.setTimeout( function() {
            if( that.terminalView.widgetLivetable ) {
                var widgetLivetableView = that.terminalView.widgetLivetable;
                var livetableHeight = widgetLivetableView.$domNode.parent().height() + 'px';
                widgetLivetableView.destroyWidget( widgetLivetableView.widgetName, widgetLivetableView.selector );
                widgetLivetableView.widgetOptions.height = livetableHeight;
                var liveTableWidth = widgetLivetableView.$domNode.parent().width();
                if (liveTableWidth > 485){
                    widgetLivetableView.mergeWidgetOptions(that.terminalView.liveTableOptions.wide);
                }else{
                    widgetLivetableView.mergeWidgetOptions(that.terminalView.liveTableOptions.narrow);
                }
                widgetLivetableView.addLivetable();

                var widgetLivesettlementView = that.terminalView.widgetLivesettlements;
                widgetLivesettlementView.setHeight();
            }
            that.resizeTimeout = null;
        }, layoutDelay );
    }

}